import axios from "axios";
import store from './../index'

// Договоры компаний (Управление → Компании → Договоры): файлы на бэке, API CompanyAgreement/*.
// Все действия возвращают Promise; ошибки 400 уже показаны snackbar'ом интерцептора axios,
// кроме blob-ответов (скачивание), где текст ошибки читается из тела здесь.

async function downloadBlob(request, fileName, fallbackError) {
  try {
    const { data } = await request();

    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    // Ответ запрошен как blob, поэтому текст ошибки (400, { error }) читаем из него
    let text = fallbackError;
    try {
      const body = error.response?.data;
      if (body instanceof Blob) {
        text = JSON.parse(await body.text()).error || text;
      } else if (body?.error) {
        text = body.error;
      }
    } catch (parseError) {
      window.console.log(parseError);
    }
    store.commit('SET_SNACKBAR', {
      text,
      timeout: 7500,
      color: 'error',
      linkText: '',
      show: true,
    });
    throw error;
  }
}

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // Список договоров компании (без файлов)
    COMPANY_AGREEMENTS: async (_, companyId) => {
      const { data } = await axios.get('/CompanyAgreement/GetByCompanyId', {
        params: { companyId }
      });

      return data;
    },

    // Добавить договор: multipart/form-data { CompanyId, BIN, ExpirationDate (yyyy-MM-dd), File }
    CREATE_COMPANY_AGREEMENT: async (_, { companyId, bin, expirationDate, file }) => {
      const form = new FormData();
      form.append('CompanyId', companyId);
      form.append('BIN', bin || '');
      form.append('ExpirationDate', expirationDate);
      form.append('File', file, file.name);

      const { data } = await axios.post('/CompanyAgreement/Create', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // show: true обязателен — без него Snackbar.vue ничего не покажет; имя файла в текст не подставляем
      // (Snackbar выводит текст через v-html, а имя файла задаёт клиент)
      store.commit('SET_SNACKBAR', {
        text: 'Договор добавлен',
        timeout: 5000,
        color: 'success',
        show: true,
      });

      return data;
    },

    DELETE_COMPANY_AGREEMENT: async (_, id) => {
      await axios.delete('/CompanyAgreement/Delete', {
        params: { id }
      });

      store.commit('SET_SNACKBAR', {
        text: 'Договор удалён',
        timeout: 5000,
        color: 'success',
        show: true,
      });

      return true;
    },

    // Скачать файл договора под оригинальным именем
    DOWNLOAD_COMPANY_AGREEMENT: (_, { id, fileName }) => downloadBlob(
      () => axios.get('/CompanyAgreement/Download', { params: { id }, responseType: 'blob' }),
      fileName || 'agreement',
      'Не удалось скачать договор'
    ),

    // Показывать ли окно «договор отсутствует или истёк» (решает бэкенд: флаг, роль аптеки, рабочие БИН без договора)
    COMPANY_AGREEMENT_MY_STATUS: async () => {
      const { data } = await axios.get('/CompanyAgreement/MyStatus');

      return {
        showWarning: !!data?.showWarning,
        missingBINs: Array.isArray(data?.missingBINs) ? data.missingBINs : [],
      };
    },

    COMPANY_AGREEMENTS_REPORT: async (_, search) => {
      const { data } = await axios.post('/CompanyAgreement/Report', search || {});

      return data;
    },

    DOWNLOAD_COMPANY_AGREEMENTS_REPORT: (_, search) => downloadBlob(
      () => axios.post('/CompanyAgreement/DownloadReport', search || {}, { responseType: 'blob' }),
      'CompanyAgreements.xlsx',
      'Не удалось сформировать отчёт'
    ),
  }
};
